/*
 * Copyright (c) 2024 CalAmp Corp.  All Rights Reserved
 */
import {DeviceFile} from '@ion/core/src/types/entities';

/**
 * Defines the searchable fields from which users can search for LMU Config
 * files.
 */
export enum LMUConfigSearchField {
  name = 'name',
  version = 'version'
}

/**
 * @internal
 *
 * Provides a utility which filters the provided options based on the `search`
 * value and the selected `field`.
 *
 * @see {@link JobTaskLMUConfigSearch}
 *
 * @param   options the full list of `DeviceFiles` which are to be filtered.
 * @param   search The search term against which the options are to be filtered.
 * @param   field The `LMUConfigSearchField` from which the value is to be
 *          returned.
 */
export const filterOptions = (
  options: DeviceFile[],
  field: LMUConfigSearchField,
  search: string) => {
  if (search) {
    const isVersion = field === LMUConfigSearchField.version;
    const value     = search.toLowerCase();
    return options.filter(({validationMetaData, name}: DeviceFile): boolean => {
      if (isVersion) {
        const {version} = validationMetaData?.fields || {};
        return version?.toString().toLowerCase().startsWith(value);
      }
      return !!(name?.toLowerCase().indexOf(value) > -1);
    });
  }
  return options;
};
